<div class="tabbable__body margin--none shadow-z-1">
  <h3>Fördelning per publicistgrupp i WOO-RBS-kampanjer</h3>
  @if (loaded.publisherGroupSettings) {
  <div>
    <p>Observera att fördelningen per publicistgrupp inte nödvändigtvis behöver stämma med det faktiska utfallet.</p>
    <form
      (ngSubmit)="updatePublisherGroups()">

      <h4>WOO RBS nationell</h4>
      @for (publisherGroup of publisherGroups; track $index) {
      <div
        class="relative display--inline-block width--30 margin-right--2x margin-bottom--2x">
        <div class="input__container">
          <label>{{publisherGroup.name}}</label>
          <input type="number" id="woo_rbs_share{{index}}" name=woo_rbs_share{{index}} [(ngModel)]="publisherGroup.woo_rbs_share" min="0" max="100" step="0.1">
        </div>
      </div>
      }
      @if (loaded.systemServiceSettings) {
        <h4>WOO RBS regional</h4>
        <div>
          <input type="checkbox" class="checkbox" name="enable_woo_local_rbs_share"
            [checked]="settings.enable_woo_local_rbs_share"
            [(ngModel)]="settings.enable_woo_local_rbs_share">
          <label for="enable_woo_local_rbs_share" class="checkbox">Aktiverad</label>
        </div>
        @for (publisherGroup of publisherGroups; track $index) {
          <div
            class="relative display--inline-block width--30 margin-right--2x margin-bottom--2x">
            <div class="input__container">
              <label>{{publisherGroup.name}}</label>
              <input type="number" id="woo_local_rbs_share{{index}}" name=woo_local_rbs_share{{index}} [(ngModel)]="publisherGroup.woo_local_rbs_share" min="0" max="100" step="0.1"
                [disabled]="!settings.enable_woo_local_rbs_share">
            </div>
          </div>
        }
      }
      @if (loaded.systemServiceSettings) {
        <h4>WOO RBS målgrupp</h4>
        <div>
          <input class="checkbox" type="checkbox" name="enable_woo_target_group_rbs_share"
             [checked]="settings.enable_woo_target_group_rbs_share" [(ngModel)]="settings.enable_woo_target_group_rbs_share">
          <label for="enable_woo_target_group_rbs_share" class="checkbox">Aktiverad</label>
        </div>
        @for (publisherGroup of publisherGroups; track $index) {
          <div class="relative display--inline-block width--30 margin-right--2x margin-bottom--2x">
            <div class="input__container">
              <label>{{publisherGroup.name}}</label>
              <input type="number" id="woo_target_group_rbs_share{{index}}" name=woo_target_group_rbs_share{{index}} [(ngModel)]="publisherGroup.woo_target_group_rbs_share" min="0" max="100" step="0.1"
                [disabled]="!settings.enable_woo_target_group_rbs_share">
            </div>
          </div>
        }
      }
      <h1></h1>
      <button type="submit" class="button margin-top--3x" value="Spara">Spara</button>
    </form>
  </div>
  <h3 class="heading-margin">Utfall WOO RBS nationell (förra månaden)</h3>
  <dot-loader [visibility]="!loaded.publisherOutcomes" description="Hämtar statistik"></dot-loader>
  @if (loaded.publisherOutcomes) {
    <app-woo-table [data]="publisherOutcomes">
      <woo-table-column header="Publicist" name="name"></woo-table-column>
      <woo-table-column header="Impressions" name="impressions">
        <ng-template #cell let-cell>
          {{cell.value | number: '1.0-2'}}
        </ng-template>
      </woo-table-column>
      <woo-table-column header="Andel" name="impressions/publisherOutcomeTotal">
        <ng-template #cell let-cell>
          {{cell.value | percent: '1.0-2'}}
        </ng-template>
      </woo-table-column>
    </app-woo-table>
  }
}
</div>
